import React, { useContext } from 'react';

import { FormikContext as FormContext } from 'formik';

import { Dialog as DialogV2 } from '@gogame/components';

export const Dialog = ({ children, ...props }) => {
  const { dirty, loading } = useContext(FormContext);
  return (
    <DialogV2 confirmOnClose={dirty} loading={loading} {...props}>
      {children}
    </DialogV2>
  );
};
